import * as React from 'react';
import { Navigate, Outlet } from 'react-router-dom';

// Components
import { Spinner } from '../Spinner';

// Contexts
import { AuthContext } from '../../contexts/Auth';

// Hooks
import { usePermission } from '../../hooks/usePermission';

// Types
import { IUserRole } from '../../types';

export const AdminRoute: React.FC = () => {
    const { authState, firebaseState } = React.useContext(AuthContext);
    const isPermitted = usePermission([IUserRole.CIC_ADMIN, IUserRole.CIC_OWNER, IUserRole.CIC_USER]);

    if (firebaseState?.initializing || authState?.initializing) return <Spinner />;
    if (authState?._id) {
        return isPermitted ? <Outlet /> : <Navigate to="/error/401" />;
    } else if (!authState?._id) {
        return <Navigate to="/login" />;
    }

    return <Spinner />;
};

export default AdminRoute;
